import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const PhysicianPage = () => {
  const columns = [
    { key: 'name', label: 'Physician Name' },
    { key: 'npi', label: 'NPI' },
    { key: 'specialty', label: 'Specialty' },
    { key: 'phone', label: 'Phone' },
    { key: 'fax', label: 'Fax' },
    { key: 'address', label: 'Address' },
    { key: 'active', label: 'Active' },
  ];

  const initialData = [
    { id: '1', name: 'DR. WILLIAMS, JAMES', npi: '1234567890', specialty: 'Internal Medicine', phone: '(713) 555-1001', fax: '(713) 555-1002', address: '123 Medical Center Dr', active: 'Yes' },
    { id: '2', name: 'DR. CHEN, LINDA', npi: '2345678901', specialty: 'Cardiology', phone: '(713) 555-2001', fax: '(713) 555-2002', address: '456 Heart Center Blvd', active: 'Yes' },
    { id: '3', name: 'DR. PATEL, RAJ', npi: '3456789012', specialty: 'Family Medicine', phone: '(713) 555-3001', fax: '(713) 555-3002', address: '789 Family Care Way', active: 'Yes' },
    { id: '4', name: 'DR. GARCIA, MARIA', npi: '4567890123', specialty: 'Pulmonology', phone: '(713) 555-4001', fax: '(713) 555-4002', address: '321 Respiratory Ln', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Physician"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Physician"
    />
  );
};

export default PhysicianPage;
